import { Flex, Typography } from 'antd'
import { FC } from 'react'
import Calculation from '../../../../types/api/calculation'
import renderDatetime from '../../../../helpers/tables/render-datetime'

interface CalculationHeadingCellProps {
    record: Calculation
}

const CalculationHeadingCell: FC<CalculationHeadingCellProps> = ({ record }) => {
    return (
        <Flex gap={18} align='center' style={{ fontSize: 12 }}>
            <span style={{ width: 250, fontSize: 16, fontWeight: 'bold' }}>
                {record.client?.name}
            </span>
            <Typography.Text type={'secondary'} style={{ marginTop: 2, marginRight: 34 }}>
                {renderDatetime(record.createdAt)}
            </Typography.Text>
            {/* <Switch checkedChildren={'Сборки'} unCheckedChildren={'Без сборок'} /> */}
        </Flex>
    )
}

export default CalculationHeadingCell
